
import React, { useState } from 'react';
import LocationCardStrip from './LocationCardStrip';
import ScoutingMap from './ScoutingMap';
import ScoutingDetails from './ScoutingDetails';

const ScoutingVault = ({ allLocationData, onShare, vaultType, onAsign, onReachEnd, onScriptAsign }: any) => {
    const [locationDetails, setLocationDetails] = useState<any>(null)
    return (
        <div className="sv-page">
            {/* Map */}
            <ScoutingMap
                pins={allLocationData}
                onPinClick={(data: any) => setLocationDetails(data)}
            />
            {/* Bottom scrollable cards */}
            <LocationCardStrip
                items={allLocationData}
                onShare={onShare}
                vaultType={vaultType}
                onAsign={onAsign}
                onScriptAsign={onScriptAsign}
                onCardClick={(data: any) => setLocationDetails(data)}
                onReachEnd={onReachEnd}
            />

            {locationDetails?.id &&
                <ScoutingDetails
                    onClose={() => setLocationDetails(null)}
                    locationData={locationDetails}
                />
            }

        </div>
    );
};

export default ScoutingVault;